import React, { useEffect, useState, useRef } from "react";
import ClipLoader from "react-spinners/ClipLoader";
import PieChart, {
  Legend,
  Series,
  Label,
  Connector,
} from "devextreme-react/pie-chart";
import { useParams } from "react-router-dom";
import { Card } from "react-bootstrap";

const override = {
  display: "block",
  margin: "0 auto",
};

const BikeStatus = () => {
  const effectRan = useRef(false);
  const { apiKey } = useParams();
  const [loading, setLoading] = useState(false);
  const [category, setCategory] = useState({});
  const chartdata = [];

  const getBikeStatus = async () => {
    setLoading(true);
    const resp = await fetch("api/BicycleStatus/counttenant/" + apiKey);
    if (resp.ok) {
      const data = await resp.json();
      setCategory(data);
      setLoading(false);
    } else {
      console.log("Error!");
    }
  };

  useEffect(() => {
    getBikeStatus();

    const autoR = setInterval(() => {
      getBikeStatus();
    }, 15*60*1000);

    return () => clearInterval(autoR);
  }, []);

  function checkValid() {
    if (category.available > 0) {
      chartdata.push({ status: "In dienst", bicycles: category.available });
    }
    if (category.outOfService > 0) {
      chartdata.push({ status: "Buiten gebruik", bicycles: category.outOfService, });
    }
    if (category.inUse > 0) {
      chartdata.push({ status: "In gebruik", bicycles: category.inUse });
    }
    if (category.inWorkShop > 0) {
      chartdata.push({ status: "In werkplaats", bicycles: category.inWorkShop });
    }
    if (category.lost > 0) {
      chartdata.push({ status: "Verloren", bicycles: category.lostBicycles });
    }
  }
  checkValid();

  return (
    <>
      <Card>
        <Card.Header className="fw-bold text-center fs-5">
        Fietsen
        </Card.Header>
        <Card.Body>
          {loading ? (
            <div>
              <ClipLoader
                color="#5b36d6"
                loading={loading}
                cssOverride={override}
                speedMultiplier="0.8"
                size={35}
                aria-label="Loading Spinner"
                data-testid="loader"
              />
            </div>
          ) : (
            <PieChart id="pie" dataSource={chartdata} palette="Blue">
              <Series argumentField="status" valueField="bicycles">
                <Label visible={true}>
                  <Connector visible={true} width={1} />
                </Label>
              </Series>
              {/* <Export enabled={true} /> */}
              <Legend
                orientation="horizontal"
                itemTextPosition="center"
                horizontalAlignment="center"
                verticalAlignment="bottom"
              />
            </PieChart>
          )}
        </Card.Body>
      </Card>
    </>
  );
};

export default BikeStatus;
